import * as AC from './actionTypes';

export const getLogs = (filters = {}) => ({
  type: AC.GET_LOGS_REQUEST,
  filters,
});

export const getCheckins = (filters = {}) => ({
  type: AC.GET_CHECKINS_REQUEST,
  filters,
});

export const getCheckinsByCustomer = (customerId, filters = {}) => ({
  type: AC.GET_CUSTOMERS_CHECKINS_REQUEST,
  customerId,
  filters,
});

export const getInvalidStatusCards = (filters = {}) => ({
  type: AC.GET_INVALID_STATUS_CARDS_REQUEST,
  filters,
});